import { render, staticRenderFns } from "./RecommendedPackages.vue?vue&type=template&id=2f41314a&scoped=true"
import script from "./RecommendedPackages.vue?vue&type=script&lang=js"
export * from "./RecommendedPackages.vue?vue&type=script&lang=js"
import style0 from "./RecommendedPackages.vue?vue&type=style&index=0&id=2f41314a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f41314a",
  null
  
)

export default component.exports